import { Controller } from '@hotwired/stimulus'
import { peekTarget, popStack, dropStaleEntries } from '../utils/navigation_history'

export default class extends Controller {
  // Prevents looping back to the same show page or returning to the form after submission —
  // in both cases falling back to the default path instead.
  navigate() {
    const currentPath = new URL(window.location.href).pathname
    dropStaleEntries(currentPath)
    const target = peekTarget() // full path incl. query string, e.g. "/kids?status=active"
    const targetPath = target ? new URL(target, window.location.origin).pathname : null
    const isValidTarget =
      target &&
      !targetPath.endsWith('/edit') &&
      !targetPath.endsWith('/new')

    if (isValidTarget) {
      this.element.href = target
      popStack()
    }

    this._markPendingRestore()
  }

  _markPendingRestore() {
    sessionStorage.setItem('scrollPendingRestore', new URL(this.element.href, window.location.origin).pathname)
  }
}
